// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Jn-z","slideIn":"Kn-z"};